import { render, staticRenderFns } from "./adress.vue?vue&type=template&id=778db96d&"
import script from "./adress.vue?vue&type=script&lang=js&"
export * from "./adress.vue?vue&type=script&lang=js&"
import style0 from "./adress.vue?vue&type=style&index=0&id=778db96d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports